import { Breadcrumbs } from 'components/uikit/Breadcrumbs';
import { Loading } from 'components/uikit/suspense/Loading';
import { format } from 'date-fns';
import { QueryFactory } from 'services/api';
import { AppLink } from '../../../components/uikit/buttons/AppLink.tsx';
import { downloadFile } from '../../../helpers/download-helper.ts';
import { useScopedTranslation } from '../../../application/localization/useScopedTranslation.ts';

export const FirmwarePage = () => {
  const fwQuery = QueryFactory.FirmwareQuery.useGetQuery(
    {},
    { throwOnError: false },
  );
  const i18n = useScopedTranslation('Page.Firmware');

  const fwClient = QueryFactory.FirmwareClient;

  const handleDownload = async (deviceGeneration: string, subtype?: string) => {
    const responseLink = await fwClient.getLink(deviceGeneration, subtype);
    downloadFile(responseLink);
  };
  return (
    <div>
      <Breadcrumbs />
      <h2>Firmware Update for Therapy Devices</h2>
      <Loading loading={fwQuery.isLoading}>
        <table className="standard">
          <tbody>
            <tr>
              <th className="left">{i18n.t('table_generation')}</th>
              <th>{i18n.t('table_current_version')}</th>
              <th>{i18n.t('table_subtype')}</th>
              <th>{i18n.t('table_release_date')}</th>
              <th></th>
            </tr>

            {fwQuery.data?.map((fw) => {
              return (
                <tr>
                  <td align="center"> {fw.deviceGeneration ?? '-'}</td>
                  <td align="center">{fw.version ?? '-'}</td>
                  <td align="center">{fw.subtype ?? '-'}</td>
                  <td align="center">
                    {fw.releaseDate ? format(fw.releaseDate, 'P') : '-'}
                  </td>
                  <td>
                    <b>
                      {fw.exists && (
                        <AppLink
                          onClick={() =>
                            handleDownload(
                              fw.deviceGeneration,
                              fw.subtype ?? '',
                            )
                          }
                          target="_self"
                        >
                          Download
                        </AppLink>
                      )}
                    </b>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Loading>
      <p>
        With the help of our software LÖWENSTEINupdate (formerly WEINMANNupdate)
        you can perform the firmware update.
      </p>
      <p>
        You can order the LÖWENSTEINupdate package directly from Löwenstein
        Medical Technology (article number WM27220).
      </p>
      <p>
        If you already have WEINMANNupdate, you will find the latest software
        below:
      </p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th className="left">Software</th>
            <th>Current Version</th>
            <th>Change</th>
            <th></th>
          </tr>
          <tr>
            <td>LÖWENSTEINupdate</td>
            <td align="center">V 1.17</td>
            <td>
              <ul>
                <li>Compatibility with Windows 10</li>
              </ul>
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/LOEWENSTEINupdate_v1.17.zip"
                  target="_blank"
                >
                  Download
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 143 MB)</span>
            </td>
          </tr>
        </tbody>
      </table>

      <p></p>
      <p>&nbsp;</p>
      <p>You can download our latest firmware from here:</p>
      <p>&nbsp;</p>
      <h3>Sleep Therapy</h3>
      <p>
        Here you can find the official firmware for all prisma LINE therapy
        devices. Save the specific file on a SD Card.
        <br />
        <b>DO NOT change the file name or the file.</b>
        <br />
        Insert the SD Card into the device and follow the instruction on the
        prisma device screen. Remove the SD Card after the update.
        <br />
        <br />
        Due to local regulations, you are responsible to use only firmware
        versions that are approved in your country.
      </p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th className="left">Device</th>
            <th>Current firmware version</th>
            <th>Change</th>
            <th>
              Download current
              <br />
              firmware version
            </th>
            <th>
              Current firmware version
              <br />
              not approved in
            </th>
            <th>
              Download older
              <br />
              firmware version
            </th>
          </tr>
          <tr>
            <td>
              prismaLINE
              <br />
              <br />
              Typ WM 100 TD
            </td>
            <td align="center">V 5.07.0002</td>
            <td>
              <ul>
                <li>Extension barometer support</li>
              </ul>
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaLINE/V5.07.0002/Update_weinmann_respiratory_device.zip"
                  target="_blank"
                >
                  Download V 5.07.0002
                </a>
              </b>
              <br />
              <span className="infotext">(zip)</span>
            </td>
            <td>
              Singapore V 5.5.0022
              <br />
              Sri Lanka V 5.01.0013
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaLINE/V5.5.0022/Update_weinmann_respiratory_device.zip"
                  target="_blank"
                >
                  Download V 5.5.0022
                </a>
              </b>
              <br />
              <span className="infotext">(zip)</span>
            </td>
          </tr>

          <tr>
            <td>
              <b>prisma SOFT max,</b>
              <br />
              <b>prisma SMART max</b>
              <br />
              <b>Typ WM 090 TD</b>
              <br />
              Serial number range:
              <br />
              26000000 - 26999999
            </td>
            <td align="center">V 3.15.3</td>
            <td>
              <ul>
                <li>General device optimization</li>
                <br />
                <br />
              </ul>
              <br />
              For further information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.3/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.3
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
            <td></td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.2/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.2
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
          </tr>
          <tr>
            <td>
              <b>prisma SOFT plus,</b>
              <br />
              <b>prisma SMART plus</b>
              <br />
              <b>Typ WM 090 TD</b>
              <br />
              Serial number range:
              <br />
              26000000 - 26999999
            </td>
            <td align="center">V 3.15.3</td>
            <td>
              <ul>
                <li>General device optimization</li>
                <br />
                <br />
              </ul>
              <br />
              For further information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.3/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.3
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
            <td></td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.2/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.2
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
          </tr>
          <tr>
            <td>
              <b>prisma SOFT</b>
              <br />
              <b>prisma SMART</b>
              <br />
              <b>Typ WM 090 TD</b>
              <br />
              Serial number range:
              <br />
              25000000 - 25999999
            </td>
            <td align="center">V 3.15.3</td>
            <td>
              <ul>
                <li>General device optimization</li>
                <br />
                <br />
              </ul>
              <br />
              For further information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.3/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.3
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
            <td></td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.15.2/Update35298.bin"
                  target="_blank"
                >
                  Download V 3.15.2
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>
          </tr>
          <tr></tr>
          <tr>
            <td>
              <b>prisma SOFT</b>
              <br />
              <b>prisma SMART</b>
              <br />
              <b>Typ WM 090 TD</b>
              <br />
              Serial number range:
              <br />
              28000000 - 28999999
            </td>
            <td align="center">V 3.7.12</td>
            <td>
              <ul>
                <li>General device optimization</li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.7.12/Update28.bin"
                  target="_blank"
                >
                  Download V 3.7.12
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>

            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>
              <b>prisma SOFT</b>
              <br />
              <b>prisma SMART</b>
              <br />
              <b>Typ WM 090 TD</b>
              <br />
              Serial number range:
              <br />
              400000 - 999999
            </td>
            <td align="center">V 3.7.12</td>
            <td>
              <ul>
                <li>General device optimization</li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>

            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaSMART/V3.7.12/Update28.bin"
                  target="_blank"
                >
                  Download V 3.7.12
                </a>
              </b>
              <br />
              <span className="infotext">(bin)</span>
            </td>

            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <p></p>
      <p className="download_link">
        <a
          href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/Overview_Firmware_Version_and_Changes.xlsx"
          target="_blank"
        >
          <img src="/loewenstein/themes/abas-theme/fixed/css/img_weinmann/xls.gif" />
          Overview Firmware Version and Changes (Sleep Therapy and Ventilation)
        </a>
      </p>
      <p>
        <br />
        <br />
      </p>

      <h3>Ventilation (LUISA)</h3>
      <p>
        Here you can find the official firmware for all LUISA ventilators.
        <br />
        Save the specific file on a USB-C flash drive.
        <br />
        <b>DO NOT change the file name or the file.</b>
        <br />
        Insert the USB-C flash drive into the device and follow the instruction
        on the LUISA
        <br />
        ventilator screen. Remove the USB-C flash drive after the update.
      </p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th className="left">Device</th>
            <th>
              Current Firmware
              <br />
              Version
            </th>
            <th>Change</th>
            <th>
              Download current
              <br />
              firmware version
            </th>
            <th>
              Current firmware version
              <br />
              not approved in
            </th>
            <th>
              Download older
              <br />
              firmware version
            </th>
          </tr>
          <tr>
            <td>
              LUISA
              <br />
              <br />
              Type LM150 TD
            </td>
            <td align="center">V 1.9.0016</td>
            <td>
              New features
              <br />
              <br />
              <ul>
                <li>
                  Bug fix of false positive disconnection alarm
                  <br />
                  (464; DisconnectionPatient)
                </li>
                <li>General device optimization and debugging</li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/Luisa/LMT35131-v1.9.0016.hex"
                  target="_blank"
                >
                  Download V 1.9.0016
                </a>
              </b>
              <br />
              <span className="infotext">(hex / 171 MB)</span>
            </td>
            <td>
              <span className="infotext">SN 50037667</span>
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <p></p>
      <p>
        <br />
        <br />
      </p>

      <h3>Ventilation (prisma VENT)</h3>
      <p>
        Here you can find the official firmware for all prisma VENT therapy
        devices.
        <br />
        Save the specific file on a SD Card.
        <br />
        <b>DO NOT change the file name or the file.</b>
        <br />
        Insert the SD Card into the device and follow the instruction on the
        prisma device screen.
        <br />
        Remove the SD Card after the update.
      </p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th className="left">Device</th>
            <th>Current Firmware Version</th>
            <th>Change</th>
            <th>
              Download current
              <br />
              firmware version
            </th>
            <th>
              Current firmware version
              <br />
              not approved in
            </th>
            <th>
              Download older
              <br />
              firmware version
            </th>
          </tr>
          <tr>
            <td>
              prisma VENT
              <br />
              <br />
              Type WM 110
              <br />
              Type WM 120
            </td>
            <td align="center">V 3.9.0017</td>
            <td>
              General device optimisation
              <br />
              <br />
              <br />
              For further information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaVENT/V3.9.0017/Update_weinmann_respiratory_device_P3_2.zip"
                  target="_blank"
                >
                  Download V 3.9.0017
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 31 MB)</span>
            </td>
            <td>
              Japan
              <br />
              (version 3.5.0022 instead)
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/prismaVENT/V3.5.0022/Update_weinmann_respiratory_device_P3_2.zip"
                  target="_blank"
                >
                  Download V 3.05.0022
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 31 MB)</span>
            </td>
          </tr>
          <tr>
            <td>prisma30ST / 30ST-C / 30ST-HFT</td>
            <td></td>
            <td colSpan={2}>
              <b>Information </b>
              <br />
              Please use the current Firmware for our prismaLINE devices and
              follow the important notes - <br />
              pls. see Sleep Therapy overview
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>
      <p>
        <br />
        <br />
      </p>

      <h3>Ventilation VENTI devices)</h3>
      <p>
        Here you will find the official firmware for all VENTI therapy devices.
        <br />
        Download the firmware file and unpack it in your destination folder. For
        the update you will also need the LÖWENSTEINupdate tool,
        <br />
        which you can find at the top of the page. For the update tool only the
        WMU file of the firmware is allowed.
      </p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th className="left">Device</th>
            <th>Current Firmware Version</th>
            <th>Change</th>
            <th></th>
          </tr>
          <tr>
            <td>
              VENTIlogic LS
              <br />
              VENTIlogic plus
              <br />
              from device number 49.732
            </td>
            <td>
              V 3.13.3
              <br />
            </td>
            <td>
              <ul>
                <li>
                  Support of alternatieve batteries
                  <br />
                  useable from SN 10.000
                </li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/WM39746_VENTIlogicLS_plus-3.13.3.wmu.zip"
                  target="_blank"
                >
                  Download V 3.13.3
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 1,15 MB)</span>
            </td>
          </tr>
          <tr>
            <td>
              VENTIlogic LS
              <br />
              VENTIlogic plus <br />
              <br />
              <b>up to device number 9.999</b>
            </td>
            <td align="center">V 2.11.3</td>
            <td>
              <ul>
                <li>Stability and performance optimization</li>
                <li>Vt min alarm now "High-priority alarm"</li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/WM27225_VENTIlogicLS_plus-2.11.3.wmu.zip"
                  target="_blank"
                >
                  Download
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 1 MB)</span>
            </td>
          </tr>
          <tr>
            <td>VENTImotion 2</td>
            <td align="center">V 2.09</td>
            <td>
              <ul>
                <li>Additional language support (Korean and Russian)</li>
                <li>Bug-fix display duration of therapy when device stops</li>
              </ul>
              <br />
              For more information please contact our Technical Service.
            </td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/WM27832_VENTImotion_2-2.09.wmu.zip"
                  target="_blank"
                >
                  Download
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 0,4 MB)</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>

      <p className="download_link">
        <a
          href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/Overview_Firmware_Version_and_Changes.xlsx"
          target="_blank"
        >
          <img src="/loewenstein/themes/abas-theme/fixed/css/img_weinmann/xls.gif" />
          Overview Firmware Version and Changes (Sleep Therapy and Ventilation)
        </a>
      </p>
      <p>
        <br />
        <br />
      </p>

      <h2>Firmware Update for Accessories</h2>
      <p>
        You can update the firmware for the remote setting software SOMNO
        <i>adjust</i> if you have the required update set.
        <br />
        Unfortunately, you can no longer order the set.
      </p>
      <p>
        The current firmware can be downloaded from here.
        <br />
        You may instead send your SOMNO<i>adjust</i> to Löwenstein Medical
        Technology and we'll make the update for you.
      </p>
      <p>The firmware update for accessories contains the following change:</p>
      <p></p>
      <table className="standard">
        <tbody>
          <tr>
            <th>Current Firmware Version</th>
            <th>What has been changed</th>
            <th></th>
          </tr>
          <tr>
            <td align="center">V 21.0</td>
            <td>Improvement of language selection</td>
            <td>
              <b>
                <a
                  href="https://login.loewensteinmedical.de/loewenstein/webdokumente/software/SOMNOadjust_UpdateDisk_V21.0.zip"
                  target="_blank"
                >
                  Download
                </a>
              </b>
              <br />
              <span className="infotext">(zip / 1,35 MB)</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p></p>

      <p>
        You will need one of the following programs to unzip the files:
        <a href="http://www.winrar.de/" target="_blank">
          WinRar
        </a>
        ,{' '}
        <a href="http://www.winzip.de/" target="_blank">
          WinZip
        </a>
        ,{' '}
        <a href="http://www.7-zip.org/" target="_blank">
          7-Zip
        </a>
      </p>

      <p>&nbsp;</p>
      <p>
        If you have any trouble downloading the file, please contact Technical
        Service.
      </p>
    </div>
  );
};
